import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router"

export const Route = createFileRoute("/_authenticated/$slug/settings/account")({
  staticData: { title: "General" },
  component: lazyRouteComponent(
    () => import("#pages/authenticated/settings/account.tsx"),
    "AccountSettings",
  ),
})
